import React, { ChangeEvent, useEffect, useState } from 'react'
import { IInputProps } from '../../../types/interfaces/IInputProps'
import { InputContainer, Input, Label } from '../input/style'
import { Error } from '../error/Error'
import { OptionsWrapper, PassportInputContainer, ChosenLanguage } from './style'
import Flag from '../flag/Flag'
import { RootState, useAppSelector } from 'store/store'
import countries, { Country } from '../../constants/countries'

export const PassportInput: React.FC<IInputProps> = ({
  callback,
  hasError,
  errorText,
  className,
  value,
  disabled,
  labelText,
}) => {
  const direction = useAppSelector(
    (state: RootState) => state.layout.language.direction,
  )
  const isLoading = useAppSelector((state) => state.layout.isLoading)

  const [country, setCountry] = useState<Country>(countries[0])

  useEffect(() => {
    if (value) {
      handleValueChange(value)
    }
  }, [country])

  const [openOptions, setOpenOptions] = useState<boolean>(false)

  const notChosenCountries = countries.filter(
    (notChosenCountry) => notChosenCountry.code !== country.code,
  )

  const isPassportNumber = (passportNumber: string) => {
    return country.regex.test(passportNumber)
  }

  const handleValueChange = (value: string) => {
    const error = !isPassportNumber(value)
    callback(value, error)
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    handleValueChange(e.target.value)
  }

  const handleLanguageChange = (selectedCountry: Country) => {
    setCountry(selectedCountry)
    setOpenOptions(false)
  }

  return (
    <InputContainer className={`${className ?? ''} ${hasError ? 'error' : ''}`}>
      <Label htmlFor="passport-input">{labelText}</Label>
      <PassportInputContainer direction={direction}>
        <Input
          title={disabled ? 'לא ניתן לערוך שדה זה' : ''}
          disabled={disabled || isLoading}
          value={value}
          type="text"
          name="passport-input"
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e)}
          aria-invalid={hasError ? 'true' : 'false'}
          aria-describedby="error-message"
        />
        <ChosenLanguage direction={direction}>
          <Flag
            flagImagePath={country.flagImagePath}
            language={country.code}
            onClick={() => setOpenOptions((prev) => !prev)}
            aria-label={`Select ${country.code} language`}
          />
          {openOptions && (
            <OptionsWrapper>
              {notChosenCountries.map((notChosenCountry) => (
                <Flag
                  key={notChosenCountry.code}
                  flagImagePath={notChosenCountry.flagImagePath}
                  language={notChosenCountry.code}
                  onClick={() => handleLanguageChange(notChosenCountry)}
                  aria-label={`Select ${notChosenCountry.code} language`}
                />
              ))}
            </OptionsWrapper>
          )}
        </ChosenLanguage>
      </PassportInputContainer>
      <Error id="error-message" hasError={hasError} errorText={errorText} />
    </InputContainer>
  )
}
